<template>
    <div class="page">
        <van-row class="gem-name">{{gemDetail.venueSubType}}</van-row>
        <van-row style="margin-bottom: 8px;">
            <van-col>
                <img class="position-left" src="../assets/location.png"/>
            </van-col>
            <van-col class="position-txt">
                {{gemDetail.venueAdress}}
            </van-col>
        </van-row>
        <van-row>
            <van-col>
                <img class="position-left" src="../assets/phone.png"/>
            </van-col>
            <van-col class="position-txt">
                {{gemDetail.linkPhone}}
            </van-col>
        </van-row>
        <van-row class="gem-title">介绍</van-row>
        <van-row class="gem-content">{{gemDetail.introduce}}</van-row>
        <van-row class="gem-title">照片</van-row>
        <van-row type="flex" class="pic-area">
            <!--<van-col v-for="(item, index) in gemDetail.imgList" :key="index">-->
                <img class="gem-pic" :src="gemDetail.pictureUrl"/>
                <!--<img class="gem-pic" src="https://lstyg.oss-cn-shenzhen.aliyuncs.com/test/d4641cef-e1ab-453e-a71b-6860ae9c84c2.png"/>-->
                <!--<img class="gem-pic" src="https://lstyg.oss-cn-shenzhen.aliyuncs.com/test/66035dfe-f46b-4215-a839-00eec268ebbc.png"/>-->
                <!--<img class="gem-pic" src="https://lstyg.oss-cn-shenzhen.aliyuncs.com/test/5c41e68a-7117-4e64-8594-042e46dbd2a0.png"/>-->
            <!--</van-col>-->
        </van-row>
        <van-row class="gem-title">开放时间</van-row>
        <van-row class="gem-content">{{gemDetail.openTime}}</van-row>
        <!--<van-row class="gem-content" >周末 9:00-21:00</van-row>-->
        <!--<van-row class="gem-notice" >备注：20：00停止售票，21：00停止营业</van-row>-->
        <van-row class="gem-title">票价</van-row>
        <van-row>{{gemDetail.priceDesc}}</van-row>
        <van-row class="gem-title">设施</van-row>
        <van-row class="gem-content">{{gemDetail.facilitiesDesc}}</van-row>
        <div class="action" @click="gotoYuyue">立即预定</div>
    </div>
</template>

<script>
    import {gemDetail} from '@/api/api'
    import {subGemList} from '@/api/api'
    import {subGemPrice} from '@/api/api'
    export default {
        name: "gem-detail",
        data(){
            return {
                gemId:this.$route.query.gemId,
                gemDetail:{
                    name:'篮球运动馆',
                    position:'天府逸家3期',
                    phone:'17780731504',
                    introduce:'本场馆包含8个场地，可自行选择，同时提供饮用水，场馆干净整洁，欢迎预定',
                    imgList:[
                        'https://imgdc.wangxiaobao.com/1591803914499@xizang1.jpeg',
                        'https://imgdc.wangxiaobao.com/1591803977253@xizang2.jpeg',
                        'https://imgdc.wangxiaobao.com/1591804011401@xizang3.jpeg'
                    ]
                }

            }
        },
        created(){
            this.getGemDetail()
        },
        methods:{
            getGemDetail(){
                let params = {
                    id:this.gemId
                }
                gemDetail(params).then(res=>{
                    if (res.code==0){
                        this.gemDetail = res.data.venue
                        this.getSubGems()
                        this.getGemPrice()
                    }
                })
            },
            getSubGems(){
                let params = {
                    id:this.gemId
                }
                subGemList(params).then(res=>{
                    if (res.code==0){

                    }
                })
            },
            getGemPrice(){
                let params = {
                    id:this.gemId
                }
                subGemPrice(params).then(res=>{
                    if (res.code==0){

                    }
                })
            },
            gotoYuyue(){
                this.$router.push({path: '/orderinfo?gemId=' + this.gemId});
            }
        }
    }
</script>

<style scoped>
    .page{
        margin-left: 16px;
        margin-right: 16px;
    }
    .gem-name{
        font-size:20px;
        font-family:PingFangSC-Semibold,PingFang SC;
        font-weight:600;
        color:rgba(40,43,49,1);
        line-height:28px;
        margin-bottom: 16px;
        margin-top: 25px;
    }
    .position-left{
        width: 10px;
        height: 13px;
        margin-right: 5px;
    }
    .position-txt{
        font-size:12px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(40,43,49,1);
        line-height:17px;
    }
    .gem-title{
        margin-top: 40px;
        margin-bottom: 12px;
        font-size:17px;
        font-family:PingFangSC-Semibold,PingFang SC;
        font-weight:600;
        color:rgba(40,43,49,1);
        line-height:24px;
    }
    .gem-content{
        font-size:15px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(103,108,117,1);
        line-height:21px;
    }
    .gem-notice{
        font-size:15px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(255,129,80,1);
        line-height:21px;
        margin-top: 4px;
    }
    .pic-area{
        width: 100%;
        height: auto;
        overflow-x: scroll;
    }
    .gem-pic{
        width:100%;
        height:auto;
        border-radius: 15px;
    }
    .action{
        width:201px;
        height:48px;
        background:rgba(255,129,80,1);
        box-shadow:0px 2px 8px 0px rgba(255,129,80,0.2);
        border-radius:25px;
        text-align: center;
        font-size:17px;
        font-family:PingFangTC-Semibold,PingFangTC;
        font-weight:600;
        color:rgba(255,255,255,1);
        line-height:48px;
        margin: 0 auto;
        margin-top: 20px;
        margin-bottom: 40px;
    }
</style>